<script lang="ts">
  import { goto } from '$app/navigation';
  import { page } from '$app/stores';

  import { createEventDispatcher } from 'svelte';

  import { get } from 'svelte/store';

  import { Switcher } from '@shared/ui/switcher';
  import { Tab } from '@shared/ui/tabs';

  export let artworksCount = 0;
  export let hasBiography = false;
  export let selectionsCount = 0;

  const dispatch = createEventDispatcher<{ switch: number }>();

  const { url } = get(page);

  const tabs: { name: string; order: number; visible: boolean }[] = [
    {
      name: 'Artist Bio',
      order: 1,
      visible: hasBiography,
    },
    {
      name: `Artworks • ${artworksCount}`,
      order: 2,
      visible: artworksCount > 0,
    },
    {
      name: `Selections • ${selectionsCount}`,
      order: 3,
      visible: selectionsCount > 0,
    },
  ];

  const tab = url.searchParams.get('tab');

  enum ArtistTabs {
    biography = 1,
    artworks = 2,
    selections = 3,
  }

  const filteredTabs = tabs.filter((tab) => tab.visible);

  $: visibleTabs = filteredTabs.length > 1 ? filteredTabs.map(({ name, order }) => ({ name, order })) : [];
  $: activeTab = tab ? ArtistTabs[tab as keyof typeof ArtistTabs] : (filteredTabs[0]?.order ?? 0);

  async function handleSwitch(e: CustomEvent<number>) {
    const currentUrl = url;
    const pathParts = currentUrl.pathname.split('/');

    const artistBasePath = pathParts[1].startsWith('artist-') ? `/${pathParts[1]}/` : '/';

    await goto(`${artistBasePath}?tab=${ArtistTabs[e.detail]}`, { replaceState: true, noScroll: true });

    activeTab = e.detail;
    dispatch('switch', 1);
  }
</script>

<div>
  <Switcher
    names="{visibleTabs}"
    activeIndex="{activeTab}"
    align="center"
    containerClass="gap-10 md:gap-15 !justify-center"
    tabClass="border-b-2 border-transparent"
    tabActiveClass="border-default-900 dark:border-white"
    on:change="{handleSwitch}"
  />

  <Tab id="{1}" activeId="{activeTab}"><slot name="biography" /></Tab>

  <Tab id="{2}" activeId="{activeTab}"><slot name="artworks" /></Tab>

  <Tab id="{3}" activeId="{activeTab}"><slot name="selections" /></Tab>
</div>
